import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Alert from "../../../Common/Alert";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";

const Show = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [receiveData, setReceiveData] = useState({});
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authData, setAuthData] = useState({});

  const fetchData = async () => {
    setLoading(true);
    try {
      const [res, authRes] = await Promise.all([
        Http.get(`/damage-return/${id}`),
        Http.get("/login-staff-detail")
      ]);
      setReceiveData(res.data);
      setAuthData(authRes.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const showAlert = (message, type) => {
    setAlert({ message, type });
    setTimeout(() => setAlert(null), 4000);
  };

  const handleApproval = (type) => {
    Swal.fire({
      title: "Are you sure, you want to approve?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, approve it!",
    }).then((result) => {
      if (result.isConfirmed) {
        let url = "";
        if (type === 'gm') {
          url = `/production-damage-return/gm-approval/${id}`
        } else if (type === 'admin') {
          url = `/production-damage-return/admin-approval/${id}`
        }

        Http.post(url).then((res) => {
          showAlert(res.data.message, res.data.type || "success");
          fetchData();
        }).catch((err) => {
          showAlert(err.response?.data?.message || "Something went wrong", "danger");
        });
      }
    });
  };

  useEffect(() => {
    if (!location.state) return;
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const items = receiveData.list
    ? Object.keys(receiveData.list).map((key) => receiveData.list[key])
    : [];

  const normalizeText = (text) => {
    if (!text) return "N/A";
    return text
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <div>
      <IsLogin />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Damage Return Details</h5>
          <div className="d-flex align-items-center">
            {authData.user_type === "gm" && receiveData.gm_approval_by === null && (
              <button
                className="btn btn-success mg-r-10"
                onClick={() => handleApproval('gm')}
              >
                <i className="fa fa-check mg-r-6"></i>GM Approval
              </button>
            )}
            {authData.user_type === "admin" && receiveData.admin_approval_by === null && (
              <button
                className="btn btn-primary mg-r-10"
                onClick={() => handleApproval('admin')}
              >
                <i className="fa fa-check mg-r-6"></i>Admin Approval
              </button>
            )}
            <Link to="/damage-return" className="btn btn-secondary">
              <i className="fa fa-arrow-left mg-r-6"></i>Back
            </Link>
          </div>
        </div>

        <div className="am-pagebody">
          <Alert alert={alert} />
          <div className="card pd-20 pd-sm-40">
            {loading ? (
              <div className="text-center">
                <ProgressSpinner />
              </div>
            ) : (
              <div className="col-lg-12 col-md-12 col-sm-12 col-12 padding">
                <div className="card">
                  <div className="card-body">
                    <div className="row mb-4">
                      <div className="col-sm-12">
                        <h5 className="mb-3">Damage Return Information:</h5>
                        <div className="row">
                          <div className="col-md-6">
                            <div>
                              <strong>Receipt No:</strong> {receiveData.receipt_no || "N/A"}
                            </div>
                            <div>
                              <strong>Date:</strong> {receiveData.date || "N/A"}
                            </div>
                            <div>
                              <strong>Time:</strong> {receiveData.time || "N/A"}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div>
                              <strong>GM Approval:</strong> {receiveData.gm_approval_by !== null ? <span className="badge badge-success">Approved</span> : <span className="badge badge-warning">Pending</span>}
                            </div>
                            <div>
                              <strong>Admin Approval:</strong> {receiveData.admin_approval_by !== null ? <span className="badge badge-success">Approved</span> : <span className="badge badge-warning">Pending</span>}
                            </div>
                            <div>
                              <strong>Status:</strong> {normalizeText(receiveData.status)}
                            </div>
                          </div>
                          <div className="col-12 mt-2">
                            <strong>Remarks:</strong> {receiveData.remarks || "N/A"}
                          </div>
                        </div>
                      </div>
                    </div>

                    {items.length > 0 && (
                      <>
                        <h5 className="mb-3">Damage Return Items</h5>
                        <div className="table-responsive-sm">
                          <table className="table table-striped table-bordered">
                            <thead>
                              <tr>
                                <th className="center">#</th>
                                <th>Product</th>
                                <th>Unit</th>
                                <th className="text-right">Qty</th>
                              </tr>
                            </thead>
                            <tbody>
                              {items.map((item, index) => (
                                <tr key={index}>
                                  <td className="center">{index + 1}</td>
                                  <td className="left strong">
                                    {
                                      item.product
                                        ? `${item.product.code} - ${item.product.name}`
                                        : (`p${item.product_group.id} - ${item.product_group.name}`|| "N/A")
                                    }                                  </td>
                                  <td>{item.product?.unit?.name || item?.product_group?.unit?.name || "N/A"}</td>
                                  <td className="text-right">{item.qty ?? "-"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </>
                    )}

                    <div className="row mt-4">
                      <div className="col-sm-12 text-center">
                        <Link to="/damage-return" className="btn btn-secondary">
                          <i className="fa fa-arrow-left mg-r-6"></i>Back to List
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Show;
